<div class="info-container">
  <button
    type="button"
    class="info-btn"
    [class.blocked]="mode === 'block'"
    [attr.aria-label]="mode === 'block' ? 'Show identifier problem details' : 'Show all identifiers'"
    (click)="togglePopover(); $event.stopPropagation()">
  </button>
  @if (isOpen) {
    <div class="info-popover" role="dialog">
      <div class="popover-heading">Product identifiers</div>
      <dl>
        @for (row of identifierRows; track row.key) {
          @if (isHighlighted(row.key)) {
            <div class="selected-row" style="display:contents;">
              <dt>{{ row.label }}</dt>
              <dd>
                @if (row.value != null) {
                  {{ row.value }}
                } @else {
                  <span class="empty">(missing)</span>
                }
              </dd>
            </div>
          } @else {
            <dt>{{ row.label }}</dt>
            <dd>
              @if (row.value != null) {
                {{ row.value }}
              } @else {
                <span class="empty">(missing)</span>
              }
            </dd>
          }
        }
        @for (extra of extraRows; track extra.label) {
          <dt>{{ extra.label }}</dt>
          <dd>
            @if (extra.value != null) {
              {{ extra.value }}
            } @else {
              <span class="empty">(missing)</span>
            }
          </dd>
        }
      </dl>
      @if (mode === 'info' && filenameToken != null) {
        <div class="footer-note">
          Filename uses <code>{{ filenameToken }}</code> per the org's convention.
        </div>
      }
      @if (mode === 'block') {
        <div class="deny-block">
          <div class="warn-heading">
            <span>✕</span>
            <span>{{ pdfcIdentifier }} is required by the org's convention</span>
          </div>
          <p>
            This product needs a {{ pdfcIdentifier }} value before it can generate a
            product-data file. Edit the product to populate the field.
          </p>
          <button type="button" class="primary-cta" (click)="requestEdit()">
            Edit product
          </button>
        </div>
      }
    </div>
  }
</div>
